import React, { useEffect, useState } from 'react'
import { Alert } from 'components/ui'
import { t } from 'i18next'
import { formatBerlinTimeNow } from 'utils/berlinTime'

const BerlinTimeHint = ({ className = 'mb-4' }) => {
    const [berlinTime, setBerlinTime] = useState(formatBerlinTimeNow())

    useEffect(() => {
        const interval = setInterval(() => {
            setBerlinTime(formatBerlinTimeNow())
        }, 10000)
        return () => clearInterval(interval)
    }, [])

    return (
        <Alert type="info" showIcon className={className}>
            {t('contracts.details.delivery.berlin_time_hint', {
                time: berlinTime,
            })}
        </Alert>
    )
}

export default BerlinTimeHint
